import React from 'react'
import Card from '@material-ui/core/Card';
import { Grid, Hidden } from '@material-ui/core'
import Typography from '@material-ui/core/Typography';
import InfoDeudas from '../Components/InfoDeudas';
import { Divider } from '@material-ui/core';
import { withRouter } from "react-router-dom";
import Button from '@material-ui/core/Button';
import servicableLogo from '../Assets/images/servicableLogo.png'
import futurityLogo from '../Assets/images/futurityLogo.png'
import { makeStyles } from "@material-ui/core/styles"
import { useTheme } from "@material-ui/core/styles"
import useMediaQuery from "@material-ui/core/useMediaQuery"
const useStyles = makeStyles({
    root: {
      backgroundColor: '#fafafa',
      marginTop: '2rem',
      marginLeft:'0.8rem',
      marginRight: '0.8rem'
    },
    media: {
        width:'200px',
        minWidth:"10%",
        paddingTop: '1%',
        paddingBottom: '1%',
        marginLeft:'2%',
      },
    Tipografia:{
        //paddingBottom: '4%',
        marginTop: '2%',
        marginLeft:'0%',
        fontSize: '290%',
        textAlign: 'center',
    }
  });
  const useStylesCustom = makeStyles(theme => ({
    nameclient: {
      [theme.breakpoints.down('md')]: {
        fontSize: '35px',
        marginTop: '2%',
        marginBottom:'3%'
      }
    }
    
  }));
const DeudasCliente = (props) => {
    const classes =  useStyles();
    const classesCustom =  useStylesCustom();
    const cliente = props.location.state
    const newQuery = () =>{
        props.history.push('/')
    }
    // console.log(cliente.infocontratos)
    return (
        <Card className={classes.root}  >
            <Grid container style={{marginLeft: '4%',marginTop:'1.2rem'}}>
                <Grid item xl={12} xs={12} md={3} lg={2} style={{textAlign:'center'}}>
                        <img className={classes.media} src={futurityLogo} alt="Italian Trulli"/>
                </Grid>
                
                    <Grid item xs={6} lg={8} >
                        <Typography className={classes.Tipografia} variant="body2" color="textSecondary" component="p">
                        <Hidden smDown className={classes.nameclient}>
                            {cliente.nombres.toUpperCase()}
                        </Hidden>

                        </Typography>
                    </Grid>
                <Grid item xs={12} lg={1}>
                    <Button style={{textAlign:'center', marginLeft:"3%", fontSize:"13", width:'90%'}}
                            variant="contained" 
                            color="secondary"
                            onClick={newQuery}>
                        <Typography style={{textAlign:'center', width:"100%", fontSize:"11"}} variant="body2" component="p">
                            {"Nueva consulta"}
                        </Typography> 
                    </Button>
                </Grid>
                <Hidden mdUp>
                    <Grid item xs={11} lg={12} >
                        <Typography className={classes.Tipografia, classesCustom.nameclient } style={{textAlign:'center'}}  variant="body2" color="textSecondary" component="p">
                            {cliente.nombres.toUpperCase()}
                            <Divider light />
                        </Typography>
                    </Grid>
                </Hidden>
                <Grid item xs={12} lg={12} style={{marginLeft:'0%'}}>
                    {
                        cliente.infocontratos.map( (item,index) =>
                            <div key={index}>
                                <InfoDeudas  contrato={item}></InfoDeudas>
                                <br></br>
                                <Divider style={{width:'90%'}}></Divider>
                                <br></br>
                            </div>
                        )
                    }
                </Grid>
            </Grid>
            <br></br>
        </Card>
    )
}

export default withRouter(DeudasCliente)
